import { Box } from 'reflexbox';

import { User, useMutualNoteCollaboratorsQuery } from '@treams/treams-network';
import { Avatar, Count, Label, Sidebar, Skeleton } from '@treams/treams-ui';

const MutualNoteCollaborators = () => {
	const { data } = useMutualNoteCollaboratorsQuery({
		fetchPolicy: 'cache-and-network',
	});

	if (!data) {
		return (
			<Skeleton.Repeat count={3}>
				<MutualNoteCollaboratorSkeleton />
			</Skeleton.Repeat>
		);
	}

	if (data.mutualNoteCollaborators.length === 0) {
		return null;
	}

	return (
		<>
			{data.mutualNoteCollaborators.map((collaborator) => (
				<Sidebar.Item
					key={collaborator.user.id}
					small
					path={`/notes/collaborator/${collaborator.user.id}`}
					exact
				>
					{({ selected }) => (
						<>
							<Box flexGrow={0} flexShrink={0}>
								<Avatar user={collaborator.user as User} size={24} />
							</Box>
							<Box ml={2} flexGrow={1} flexShrink={1}>
								{collaborator.user.firstName} {collaborator.user.lastName}
							</Box>
							<Count count={collaborator.count} selected={selected} />
						</>
					)}
				</Sidebar.Item>
			))}
		</>
	);
};

const MutualNoteCollaboratorSkeleton = () => {
	return (
		<Sidebar.Custom small>
			<Box flexGrow={0} flexShrink={0}>
				<Avatar.Skeleton size={24} />
			</Box>
			<Box ml={2} flexGrow={1} flexShrink={1}>
				<Label.Skeleton />
			</Box>
		</Sidebar.Custom>
	);
};

export default MutualNoteCollaborators;
